module.exports = __webpack_public_path__ + "img/9788947521321.0dee0977.jpg";